import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { observer } from "mobx-react";
import { uuid } from "core/utils";
import { Content } from "core/layouts";
import { BaasicButton, NumericInput } from "core/components";

const InventoryCalculationCutbackEditTemplate = function ({ inventoryCalculationCutbackEditViewStore }) {
	const {
		item,
		inventoryCalculationCutbacks,
		editItem,
		contentLoading,
		updateItems,
		quantity,
		soQuantity,
		adjustedQtySum,
		isDone,
		rootStore,
		onAdjustedQuantityFieldBlur,
		showPatientTemplates,
		isCutback,
		editCutbackQuantity,
		updateCutbackAdjustedQty,
		isNewFlow2
	} = inventoryCalculationCutbackEditViewStore;
	return (
		<div className="container u-padd--y--sml--no-inherit">
			<div className="content__main">
				<div key={uuid} className="row">
					<div className="col col-sml-12 col-lrg-12">
						<div className="card card--primary u-mar--x--lrg">

							<div className="container u-mar--bottom--sml u-padd--top--sml">
								<div className="row u-mar--bottom--sml">
									<div className="col u-mar--right--auto">
										<b>Item Name: </b>{item}
										<br></br>
										Calculated Quantity: <b>{quantity}</b>
										{(isCutback) ?
											<div>Sales Order Quantity: <b>{soQuantity}</b></div> : null}
										{(isCutback) ?
											<div className="u-flex--default">
												Total Cutback Quantity: 
												{isDone ?
													<b> {adjustedQtySum}</b>
													:
													<NumericInput
														className="u-mar--left--tny"
														showLabel={false}
														onChange={(e) => { editCutbackQuantity(e.target.value) }}
														onBlur={() => { updateCutbackAdjustedQty(); }}
														value={adjustedQtySum}
														min="0"
													/>
												}
											</div> : null}
									</div>
									<div className="col col-lrg-6">
										<div className="col u-mar--left--auto">
											<BaasicButton
												className="btn btn--base btn--ghost u-push u-push u-mar--left--tny"
												label="Back"
												onClick={() => rootStore.routerStore.goBack()}
											></BaasicButton>
										</div>
										{isDone ?
											""
											:
											isCutback ? <div className="col u-mar--left--auto">
												<BaasicButton
													className="btn btn--base btn--primary u-push u-push u-mar--left--tny"
													label="Save"
													onClick={() => { updateItems() }}
												></BaasicButton>
											</div> : null
										}
									</div>
								</div>
								<div className="content__main">
									<Content loading={contentLoading}>
										<div className="row">
											<TemplateItemsTable
												templateItems={inventoryCalculationCutbacks}
												editItem={editItem}
												isDone={isDone}
												onAdjustedQuantityFieldBlur={onAdjustedQuantityFieldBlur}
												showPatientTemplates={showPatientTemplates}
												isNewFlow2={isNewFlow2}
												isCutback={isCutback}
											/>
										</div>
									</Content>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

InventoryCalculationCutbackEditTemplate.propTypes = {
	inventoryCalculationCutbackEditViewStore: PropTypes.object.isRequired,
	t: PropTypes.func,
};

// Develop wrapped this class with `@observer`; the mobx-undecorate
// codemod stripped the decorator without converting to the new
// `observer(Component)` call form, so the table stopped subscribing
// to the observables it reads. Restore the wrap.
const TemplateItemsTable = observer(class TemplateItemsTable extends React.Component {
	constructor(props) {
		super(props);
	}

	selectValue = (e) => e.target.select();

	render() {
		const { templateItems, editItem, isDone, onAdjustedQuantityFieldBlur, showPatientTemplates, isCutback, isNewFlow2 } = this.props;
		return (
			<table className="table--preview">
				<thead>
					<tr>
						<th className="type--left" width="25%">Patient Name</th>
						{!isNewFlow2 && <th className="type--left" width="36%">Reference</th>}
						{isNewFlow2 && <th className="type--left" width="18%">Eligibility Status</th>}
						{isNewFlow2 && <th className="type--left" width="18%">Clinical Status</th>}
						<th className="type--left" width="13%">SO Qty</th>
						{isCutback ? <th className="type--left" width="13%">CUTBACK QTY</th> : null}
						{isCutback ? <th className="type--left" width="13%">NEW SO QTY</th> : null}
					</tr>
				</thead>
				<tbody>
					{templateItems.map((item, index) => {
						return (<tr key={item.id} ref={(ref) => { ref; return true; }}>
							<td className="type--left c-pointer table--clickable" onClick={() => { showPatientTemplates(item.patientId, item.patientKey === "" ? null : item.patientKey) }}>{item.patient}</td>
							{!isNewFlow2 && <td className="type--left">{item.importReference}</td>}
							{isNewFlow2 && <td className="type--left">{item.eligibilityStatus}</td>}
							{isNewFlow2 && <td className="type--left">{item.clinicalStatus}</td>}
							<td className="type--left">{item.soQty}</td>
							{(isDone || item.isBillableToMedicare) && isCutback ?
								<td className="type--left">{item.adjustedQty}</td>
								:
								isCutback ? <td style={{ padding: "0px" }}>
									<NumericInput
										min={0}
										value={item.adjustedQty}
										disabled={false}
										showLabel={false}
										onChange={(e) => {
											editItem(index, e.target.value, 'adjustedQty')
										}}
										onBlur={(e) => {
											onAdjustedQuantityFieldBlur(index, e.target.value);
										}}
									/></td> : null
							}
							{isCutback ? <td className="type--left">{item.difference}</td> : null}
						</tr>);
					}
					)}
				</tbody>
			</table>
		);
	}
});

TemplateItemsTable.propTypes = {
	templateItems: PropTypes.object,
	editItem: PropTypes.func,
	validate: PropTypes.func,
	isDone: PropTypes.bool,
	onAdjustedQuantityFieldBlur: PropTypes.func,
	showPatientTemplates: PropTypes.func,
	isNewFlow2:  PropTypes.bool,
	isCutback: PropTypes.bool
};

export default defaultTemplate(InventoryCalculationCutbackEditTemplate);